'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AwayStatusIndicator = require('./AwayStatusIndicator');

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

var _TypingStatusIndicator = require('./TypingStatusIndicator');

var _TypingStatusIndicator2 = _interopRequireDefault(_TypingStatusIndicator);

var _Avatar = require('./Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default,
        TypingStatusIndicator: _TypingStatusIndicator2.default,
        Avatar: _Avatar2.default
    },
    props: ['network', 'user', 'nicklist'],
    computed: {
        userColour: function userColour() {
            if (this.nicklist.useColouredNicks) {
                return this.user.getColour();
            }
            return '';
        },
        shouldShowAvatars: function shouldShowAvatars() {
            return this.nicklist.buffer.setting('nicklist_avatars');
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NicklistUser"]
window._kiwi_exports.components.NicklistUser = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NicklistUser.vue
// module id = /xsI
// module chunks = 1